import { toast } from "react-toastify";
import { deleteApi, getApi, postApi, putApi } from "../Services/apiService";
import { exportMethods, exportShippingMethods } from "../Services/importExport";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import React from "react";
import { format } from 'date-fns';
import { buildCellData, handleCellContextMenu, cellHasRemarks, getCellDataAttributes } from './cellRemarkHelper';
const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
export const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;

// Centralized timezone aliases mapping
export const timezoneAliases = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'America/New_York': 'America/New_York',
  'UTC': 'UTC',
  'Etc/GMT-8': 'Asia/Hong_Kong',
  'Etc/GMT-5': 'America/New_York'
  // Add more aliases as needed
};

// Get canonical timezone from user's timezone
export const getCanonicalTimezone = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezoneAliases[timeZone] || timeZone;
};



export const checkAddPermission = (data, permissionName) => {
  if (!data || !Array.isArray(data)) return false;

  const permission = data.find(item => item.name === permissionName);
  return permission ? permission.add === 1 : false;
};

export const checkEditPermission = (data, permissionName) => {
  if (!data || !Array.isArray(data)) return false;

  const permission = data.find(item => item.name === permissionName);
  return permission ? permission.update === 1 : false;
};
export const checkViewPermission = (data, permissionName) => {
  if (!data || !Array.isArray(data)) return false;

  const permission = data.find(item => item.name === permissionName);
  return permission ? permission.view === 1 : false;
};

export const checkDeletePermission = (data, permissionName) => {
  if (!data || !Array.isArray(data)) return false;

  const permission = data.find(item => item.name === permissionName);
  return permission ? permission.delete === 1 : false;
};

export const checkPermission = (requiredPermission, data) => {
  if (!requiredPermission) return true; // No permission required

  if (!data || !data.permissions) {
    return false; // Permissions not loaded yet
  }

  // Your existing canView logic
  return data.permissions.find((item) => item.name === requiredPermission)?.view === 1;
}

export const handleImportClickFile = (setShowImportModal, setImportFile, setImportErrors) => {
  setShowImportModal(true);
  setImportFile(null);
  setImportErrors({ file: '', general: '' });
};

export const closeImportModalFile = (setShowImportModal, setImportFile, setImportErrors) => {
  setShowImportModal(false);
  setImportFile(null);
  setImportErrors({ file: '', general: '' });
};

export const handleUpdateDataCheckbox = (data, val, setDatas) => {
  const value = val.target.checked
  setDatas((prevMethods) =>
    prevMethods.map((method) =>
      method.id === data.id
        ? { ...method, status: value } // Toggle status on click
        : method
    )
  );
}
export const handleUpdateAllCheckbox = (isChecked, setDatas) => {
  setDatas(prevMethods =>
    prevMethods.map(method => ({
      ...method,
      status: isChecked // Set all statuses to the checkbox's checked state
    }))
  );
};

export const handleExportFile = async (data, searchQuery, fileName, route) => {
  const idsStatus = data
    .filter(item => 'status' in item && item.status === true)
    .map(item => item.id);
  const val = {
    search: searchQuery,
    ids: idsStatus,
    // is_sample:1
  }
  const res = await exportMethods(val, fileName, route)
}
export const handleExportFileProduct = async (data, searchQuery, fileName, route, selectedBrandName) => {
  const idsStatus = data
    .filter(item => 'status' in item && item.status === true)
    .map(item => item.id);
  // const idBrand = selectedBrandName
  // .filter(item => 'status' in item && item.status === true)
  // .map(item => item.id);
  const val = {
    search: searchQuery,
    ids: idsStatus,
    brandIds: selectedBrandName
    // is_sample:1
  }
  const res = await exportMethods(val, fileName, route)
}
export const handleExportFilePrepackProduct = async (searchQuery, fileName, route, selectedPrepackProductIds, selectedCategoryIds, selectedBrandName, selectedOriginIds, selectedProductGroupVarietyIds, selectedPicImport, selectedPicSales, selectedBarcode, selectedPaCode, selectedConvertType, selectedPrepackType) => {
  const val = {
    ids: selectedPrepackProductIds,
    category_ids: selectedCategoryIds,
    origin_ids: selectedOriginIds,
    brands: selectedBrandName,
    product_ids: selectedProductGroupVarietyIds,
    pic_staff_member_import: selectedPicImport,
    pic_staff_member_sales: selectedPicSales,
    search: searchQuery,
    barcodes: selectedBarcode,
    pa_codes: selectedPaCode,
    convert_types: selectedConvertType,
    prepack_types: selectedPrepackType
  }
  const res = await exportMethods(val, fileName, route)
}
export const handleExportFileInventory = async (data, searchQuery, fileName, route, selectedBrandName, selectedCategoryIds, selectedOriginIds, selectedProductIds, dateState) => {
  const idsStatus = data
    .filter(item => 'status' in item && item.status === true)
    .map(item => item.id);
  // const idBrand = selectedBrandName
  // .filter(item => 'status' in item && item.status === true)
  // .map(item => item.id);
  const val = {
    search: searchQuery,
    ids: idsStatus,
    brandIds: selectedBrandName,
    categoryIds: selectedCategoryIds,
    originIds: selectedOriginIds,
    productIds: selectedProductIds,
    from_date: dateState?.startDate,
    to_date: dateState?.endDate,
    export: 1
    // is_sample:1
  }
  const res = await exportMethods(val, fileName, route)
}
export const handleExportFileArrival = async (searchQuery, fileName, route, selectedCategoryIds, selectedOriginIds, selectedStatus, startDate, endDate, canonicalTimezone, selectedPicImport, selectedPicSales, etaOrderValue) => {
  const val = {
    sort_order: etaOrderValue,
    search: searchQuery,
    categoryIds: selectedCategoryIds,
    originIds: selectedOriginIds,
    from_date: startDate,
    to_date: endDate,
    timezone: canonicalTimezone,
    picStaffMemberImport: selectedPicImport,
    picStaffMemberSales: selectedPicSales,
    status: selectedStatus,
    sort_column: 'eta',
  }
  const res = await exportMethods(val, fileName, route)
}
export const handleExportFileReserve = async (data, from, to, fileName, route, selectedBrandName, selectedOriginIds, selectedCategoryIds, selectedCustomerIds, searchQuery) => {
  const idsStatus = data
    .filter(item => 'status' in item && item.status === true)
    .map(item => item.id);
  // const idBrand = selectedBrandName
  // .filter(item => 'status' in item && item.status === true)
  // .map(item => item.id);
  const val = {
    from_date: from,
    to_date: to,
    categoryIds: selectedCategoryIds,
    originIds: selectedOriginIds,
    customerGroupIds: selectedCustomerIds,
    brandIds: selectedBrandName,
    search: searchQuery,
  }
  const res = await exportMethods(val, fileName, route)
}

export const toggleActiveStatusData = async (data, val, setIsLoading, dataFetch, navigate) => {
  try {
    setIsLoading(true);
    const response = await putApi(data, val);

    if (response?.success) {
      toast.success(response.msg || 'Status updated successfully');
      // if(data.id === data?.id){
      //     localStorage.clear()
      //     navigate('/')
      //   }
      await dataFetch();
    } else {
      toast.error(response?.msg || 'Failed to update status');
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || 'Failed to update status';
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
  }
};

export const confirmDeleteData = async (todelete, setIsLoading, fetchData, setShowDeleteModal, settoDelete, route, type) => {
  if (!todelete) return;

  try {
    setIsLoading(true);
    const response = await deleteApi(route);

    if (response?.success) {
      toast.success(response.msg || `${type} deleted successfully`);
      await fetchData();
    } else {
      toast.error(response?.msg || `Failed to delete ${type}`);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || `Failed to delete ${type}`;
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
    setShowDeleteModal(false);
    settoDelete(null);
  }
};

export const setupEditFormData = (data, setFormData, setMethodType, setToEdit, formDataCopy) => {
  if(!data){
    setFormData(formDataCopy);
    setMethodType('add');
    setToEdit(null);
    return;
  }
  const updatedFormData = Object.fromEntries(
    Object.keys(formDataCopy)
      .filter(key => data.hasOwnProperty(key)) // Only include keys that exist in data
      .map(key => [key, data[key]])
  );
  setFormData(updatedFormData);
  setMethodType('edit');
  setToEdit(data);
};

export const handleInputChangeData = (e, setFormData, touched, setErrors) => {
  const { name, value, type, checked } = e.target;
  if (name !== 'regular_order_days') {
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  }

  if (name === 'regular_order_days') {
    setFormData(prev => {
      // Special handling for regular_order_days array
      if (name === 'regular_order_days') {
        const currentDays = prev.regular_order_days || [];
        const dayValue = value; // The day being toggled (e.g., "Monday")

        return {
          ...prev,
          regular_order_days: currentDays.includes(dayValue)
            ? currentDays.filter(day => day !== dayValue) // Remove if exists
            : [...currentDays, dayValue] // Add if new
        };
      }

      // Default handling for other fields
      return {
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      };
    });
  }

  if (touched[name]) {
    validateFieldData(name, value, setErrors);
  }
};

export const validateFieldData = (fieldName, value, setErrors, customerFieldName=null) => {
  let error = '';
  if (fieldName === 'regular_order_days') {
    if (!value || !Array.isArray(value) || value.length === 0) {
      error = 'At least one day must be selected';
    }
  }
  else if (typeof value === 'number') {
    if (isNaN(value)) {
      error = `${fieldName} must be a valid number`;
    }
  }
  // Standard field validation
  else {
    // const isString = typeof value === 'string';
    //   const trimmedValue = isString ? value.trim() : '';
    if (!value?.trim() && fieldName !== 'is_active') {
      // if ((!value|| !trimmedValue) && fieldName !== 'is_active') {
      error = `${customerFieldName || fieldName} is required`;
    } else if (fieldName === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      error = 'Please enter a valid email address';
    } else if (fieldName === 'name' && value.length > 50) {
      error = 'Name should be less than 50 characters';
    }
  }

  setErrors(prev => ({
    ...prev,
    [fieldName]: error
  }));

  return !error;
};

export const handleBlurData = (e, setTouched, setErrors, customerFieldName=null) => {
  const { name, value } = e.target;
  setTouched(prev => ({
    ...prev,
    [name]: true
  }));
  validateFieldData(name, value, setErrors, customerFieldName);
};

export const fetchProductOriginDataList = async (query, setOrigin) => {
  try {
    const resp = await getApi(`/product-origin?per_page=999`);
    if (resp?.success === true) {
      setOrigin(resp?.data?.productOrigins?.data || []);
    }
  } catch (error) {
    toast.error('Failed to fetch origin details', 'error');
  } finally {
  }
};

export const handleUpdateSingleData = async (toEdit, setIsLoading, fetchData, formData, setMethodType, setFormData, setErrors, setTouched, route, type, formDataCopy) => {
  if (!validateForm(setTouched, formData, setErrors, formDataCopy) || !toEdit) {
    toast.error('Please fix the validation errors');
    return;
  }

  try {
    setIsLoading(true);
    const response = await putApi(route, formData);

    if (response?.success) {
      toast.success(response.msg || `${type} updated successfully`);
      await fetchData();
      setMethodType('');
      resetForm(setFormData, setErrors, setTouched, formDataCopy);
    } else {
      toast.error(response?.msg || `Failed to update ${type}`);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || `Failed to update ${type}`;
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
  }
};

export const handleUpdateSingleDataUrlEncoded = async (
  toEdit,
  setIsLoading,
  fetchData,
  formData,
  setMethodType,
  setFormData,
  setErrors,
  setTouched,
  route,
  type,
  formDataCopy,
  requiredFields
) => {

  const emptyFields = requiredFields.filter(field =>
    formData[field] === undefined || formData[field] === null || formData[field] === ''
  );

  if (emptyFields.length > 0) {
    const newErrors = {};
    emptyFields.forEach(field => {
      newErrors[field] = 'This field is required';
    });
    setErrors(newErrors);
    toast.error('Please fill all required fields');
    return;
  }
  // if (!validateForm(setTouched, formData, setErrors, formDataCopy) || !toEdit) {
  //   // toast.error('Please fix the validation errors');
  //   return;
  // }

  try {
    setIsLoading(true);
    // Convert formData to x-www-form-urlencoded format using URLSearchParams
    const urlEncodedData = new URLSearchParams();
    for (const key in formData) {
      urlEncodedData.append(key, formData[key]);
    }

    const response = await putApi(route, urlEncodedData.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    if (response?.success) {
      toast.success(response.msg || `${type} updated successfully`);
      await fetchData();
      setMethodType('');
      resetForm(setFormData, setErrors, setTouched, formDataCopy);
    } else {
      toast.error(response?.msg || `Failed to update ${type}`);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || `Failed to update ${type}`;
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
  }
};

export const validateFormArrival = (setTouched, formData, setErrors, formDataCopy) => {
  let isValid = true;
  const newErrors = {};

  // Validate each field
  for (const key in formDataCopy) {
    // Mark field as touched
    setTouched(prev => ({ ...prev, [key]: true }));

    // Required field validation
    if (formDataCopy[key].required && !formData[key]) {
      newErrors[key] = 'This field is required';
      isValid = false;
    }

    // Array validation - must contain at least one value
    if (Array.isArray(formData[key])) {
      if (formDataCopy[key].required && formData[key].length === 0) {
        newErrors[key] = 'Please select at least one option';
        isValid = false;
      }
    }
  }

  setErrors(newErrors);
  return isValid;
};

export const handleUpdateSingleDataArrival = async (
  toEdit,
  setIsLoading,
  fetchData,
  formData,
  setMethodType,
  setFormData,
  setErrors,
  setTouched,
  route,
  type,
  formDataCopy
) => {
  if (!validateFormArrival(setTouched, formData, setErrors, formDataCopy) || !toEdit) {
    toast.error('Please fix the validation errors');
    return;
  }

  try {
    setIsLoading(true);
    const response = await putApi(route, formData);

    if (response?.success) {
      toast.success(response.msg || `${type} updated successfully`);
      await fetchData();
      setMethodType('');
      resetForm(setFormData, setErrors, setTouched, formDataCopy);
    } else {
      toast.error(response?.msg || `Failed to update ${type}`);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || `Failed to update ${type}`;
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
  }

  // try {
  //   setIsLoading(true);
  //   const urlEncodedData = new URLSearchParams();
  //   for (const key in formData) {
  //     if (Array.isArray(formData[key])) {
  //       formData[key].forEach(item => urlEncodedData.append(`${key}`, item));
  //     } 
  //     else if (typeof formData[key] === 'object' && formData[key] !== null) {
  //       urlEncodedData.append(key, JSON.stringify(formData[key]));
  //     }
  //     else if (formData[key] !== undefined && formData[key] !== null) {
  //       urlEncodedData.append(key, formData[key]);
  //     }
  //   }

  //   const response = await putApi(route, urlEncodedData.toString(), {
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded'
  //     }
  //   });

  //   if (response?.success) {
  //     toast.success(response.msg || `${type} updated successfully`);
  //     await fetchData();
  //     setMethodType('');
  //     resetForm(setFormData, setErrors, setTouched, formDataCopy);
  //   } else {
  //     toast.error(response?.msg || `Failed to update ${type}`);
  //   }
  // } catch (error) {
  //   const errorMsg = error.response?.data?.msg || error.message || `Failed to update ${type}`;
  //   toast.error(errorMsg);
  // } finally {
  //   setIsLoading(false);
  // }
};

// export  const resetForm = (setFormData,setErrors,setTouched) => {
//   setFormData({
//     email: '',
//     name: '',
//     is_active: 1
//   });
//   setErrors({
//     email: '',
//     name: ''
//   });
//   setTouched({
//     email: false,
//     name: false
//   });
// };

export const resetForm = (setFormData, setErrors, setTouched, formDataCopy) => {
  const resetData = Object.fromEntries(
    Object.entries(formDataCopy).map(([key, value]) => [
      key,
      typeof value === 'boolean' ? false : (typeof value === 'number' ? value : '')
    ])
  );

  const resetErrors = Object.fromEntries(
    Object.keys(formDataCopy).map(key => [key, ''])
  );

  const resetTouched = Object.fromEntries(
    Object.keys(formDataCopy).map(key => [key, false])
  );

  setFormData(resetData);
  setErrors(null);
  setTouched(resetTouched);
};

export const resetFormData = (setFormData, setErrors, toEdit, formDataCopy) => {
  // : typeof formDataCopy[key] === 'object' && formDataCopy[key] instanceof Date
  // ? null  // reset date to null
  // : ''

  const resetData = Object.fromEntries(
    Object.entries(formDataCopy).map(([key]) => [
      key,
      // If field exists in toEdit, use that value, otherwise reset appropriately
      toEdit?.[key] !== undefined
        ? toEdit[key]
        : typeof formDataCopy[key] === 'boolean'
          ? false
          : typeof formDataCopy[key] === 'number'
            ? 0
            : ''
    ])
  );
  setFormData(resetData)
  setErrors([]);
  // setErrors({});
}

export const validateForm = (setTouched, formData, setErrors, formDataCopy) => {
  let isValid = true;
  // const newTouched = {
  //   email: true,
  //   name: true
  // };
  // setTouched(newTouched);

  Object.keys(formData).forEach(key => {
    if (key !== 'is_active') {
      const valid = validateFieldData(key, formData[key], setErrors);
      if (!valid) isValid = false;
    }
  });

  return isValid;
};

// export const fetchGetList = async (setIsLoading,setError,searchQuery,setProduct,type) => {
//   try {
//     setIsLoading(true);
//     setError(null);
//     const response = await getApi(`/product?search=${encodeURIComponent(searchQuery)}`);

//     if (response?.success) {
//       setProduct(response.data.suppliers?.data || []);
//     } else {
//       setError(response?.msg || `Failed to fetch ${type}`);
//     }
//   } catch (error) {
//     setError(error.message || `Failed to fetch ${type}`);
//   } finally {
//     setIsLoading(false);
//   }
// };

export const handleAddSingleData = async (setIsLoading, formData, fetchData, setMethodType, formDataCopy, setTouched, setError, route, type, setFormData) => {
  if (!validateForm(setTouched, formData, setError, formDataCopy)) {
    toast.error('Please fix the validation errors');
    return;
  }

  try {
    setIsLoading(true);
    const response = await postApi(route, formData);

    if (response?.success == true) {
      toast.success(response.msg || `${type} added successfully`);
      await fetchData();
      setMethodType('');
      resetForm(setFormData, setError, setTouched, formDataCopy);
    } else {
      toast.error(response?.msg || `Failed to add ${type}`);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || 'Failed to add seller';
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
  }
};
export const handleAddSingleDataArrival = async (setIsLoading, formData, fetchData, setMethodType, formDataCopy, setTouched, setError, route, type, setFormData) => {
  if (!validateFormArrival(setTouched, formData, setError, formDataCopy)) {
    toast.error('Please fix the validation errors');
    return;
  }

  try {
    setIsLoading(true);
    const response = await postApi(route, formData);

    if (response?.success == true) {
      toast.success(response.msg || `${type} added successfully`);
      await fetchData();
      setMethodType('');
      resetForm(setFormData, setError, setTouched, formDataCopy);
    } else {
      toast.error(response?.msg || `Failed to add ${type}`);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || 'Failed to add seller';
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
  }
};

export const handleAddSingleDataFormData = async (
  setIsLoading,
  fetchData,
  formData,
  setMethodType,
  setFormData,
  setError,
  setTouched,
  route,
  type,
  formDataCopy,
  requiredFields
) => {
  // This will NOT treat 0 as empty.
  const emptyFields = requiredFields.filter(field =>
    formData[field] === undefined || formData[field] === null || formData[field] === ''
  );

  if (emptyFields.length > 0) {
    const newErrors = {};
    emptyFields.forEach(field => {
      newErrors[field] = 'This field is required';
    });
    setError(newErrors);
    toast.error('Please fill all required fields');
    return;
  }
  // if (!validateForm(setTouched, formData, setError, formDataCopy)) {
  //   // toast.error('Please fix the validation errors');
  //   return;
  // }

  try {
    setIsLoading(true);

    // Convert formData object to FormData
    const formDataPayload = new FormData();

    // Append all fields to FormData
    for (const key in formData) {
      // Skip undefined or null values
      if (formData[key] !== undefined && formData[key] !== null) {
        formDataPayload.append(key, formData[key]);
      }
    }

    const response = await postApi(route, formDataPayload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    if (response?.success === true) {
      toast.success(response.msg || `${type} added successfully`);
      await fetchData();
      setMethodType('');
      resetForm(setFormData, setError, setTouched, formDataCopy);
    } else {
      toast.error(response?.msg || `Failed to add ${type}`);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.msg || error.message || `Failed to add ${type}`;
    toast.error(errorMsg);
  } finally {
    setIsLoading(false);
  }
};

export const TableFooter = ({ pageCount, handlePageClick, currentPage }) => {
  return (
    // <ReactPaginate
    //   previousLabel={<img src={window.getPublicUrl("/assets/images/perivous.svg")}/>}
    //   nextLabel={<img src={window.getPublicUrl("/assets/images/next.svg")}/>}
    //   breakLabel="..."
    //   onPageChange={(selectedItem) => handlePageClick(selectedItem.selected + 1)}
    //   pageCount={pageCount}
    //   forcePage={currentPage - 1}
    //   marginPagesDisplayed={2}
    //   pageRangeDisplayed={3}
    //   containerClassName="pagination"
    //   activeClassName="active"
    //   previousClassName={currentPage === 1 ? 'disabled' : 'page-item'}
    //   nextClassName={currentPage === pageCount ? 'disabled' : 'page-item'}
    //   previousLinkClassName="page-link"
    //   nextLinkClassName="page-link"
    //   pageLinkClassName="page-link"
    //   breakLinkClassName="page-link"
    //   pageClassName="page-item"
    //   // nextClassName="page-item"
    //   // previousClassName="page-item"
    //   breakClassName="page-item"
    // />
    <ReactPaginate
      previousLabel={currentPage === 1 ? <img src={window.getPublicUrl("/assets/images/perivous.svg")} alt="Previous" /> : <img src={window.getPublicUrl("/assets/images/next-icon.svg")} alt="Next" />}
      nextLabel={currentPage === pageCount ? <img src={window.getPublicUrl("/assets/images/next-green.svg")} alt="Next" /> : <img src={window.getPublicUrl("/assets/images/next-white.svg")} alt="Next" />}
      breakLabel="..."
      onPageChange={(selectedItem) => handlePageClick(selectedItem.selected + 1)}
      pageCount={pageCount}
      forcePage={currentPage - 1}
      marginPagesDisplayed={2}  // Always show 2 pages at start/end
      pageRangeDisplayed={3}    // Show 3 pages around current
      containerClassName="pagination"
      activeClassName="active"
      previousClassName={currentPage === 1 ? 'disabled' : 'page-item icon'}
      nextClassName={currentPage === pageCount ? 'disabled' : 'page-item'}
      previousLinkClassName="page-link"
      nextLinkClassName="page-link"
      pageLinkClassName="page-link"
      breakLinkClassName="page-link"
      pageClassName="page-item"
      breakClassName="page-item"
    />
  );
};

// export const filteredCategories = (searchTerm,data)=>{
//   const searchLower = searchTerm.toLowerCase();

//   const filterData = data?.filter(category => {
//     if (searchTerm === '') return data;

//     const nameMatch = (category.name || '').toLowerCase().includes(searchLower);
//     const filedOnly = (category|| '').toLowerCase().includes(searchLower);
//     const nameEnMatch = category.name_en 
//       ? category.name_en.toLowerCase().includes(searchLower)
//       : false;

//     return nameMatch || nameEnMatch || filedOnly;
//   }) || [];

//   return filterData;
// }
export const filteredCategories = (searchTerm, data) => {
  // Return all data if search term is empty
  if (!searchTerm) return data || [];

  const searchLower = searchTerm.toLowerCase();
  return data?.filter(category => {
    // Safely check name
    const nameMatch = (!category?.name ? (category?.name_en ? category?.name_en : category) : category?.name || '').toLowerCase().includes(searchLower);
    // const nameMatch = (
    //   category?.name?.toLowerCase() ||
    //   category?.name_en?.toLowerCase() ||
    //   category?.name_tc?.toLowerCase() ||
    //   (typeof category === 'string' ? category.toLowerCase() : '')
    // ).includes(searchLower);
    // const nameMatchOnly = (!category?.id ? category || '').toLowerCase().includes(searchLower);

    // Safely check name_en if it exists
    // const nameEnMatch = category?.name_en 
    //   ? category?.name_en.toLowerCase().includes(searchLower)
    //   : false;

    // Safely check code if you want to include it in search
    const codeMatch = category?.code
      ? category?.code.toLowerCase().includes(searchLower)
      : false;

    return nameMatch || codeMatch;
  }) || [];
};
export const filteredProduct = (searchTerm, data) => {
  if (!searchTerm) return data || [];

  const searchLower = searchTerm.toLowerCase();

  return data?.filter(category => {
    const name = category?.name || category?.name_en || category || '';
    const nameMatch = name.toLowerCase().includes(searchLower);
    const nameTcMatch = category?.name_tc
      ? category.name_tc.toLowerCase().includes(searchLower)
      : false;
    const codeMatch = category?.code
      ? category.code.toLowerCase().includes(searchLower)
      : false;

    return nameMatch || nameTcMatch || codeMatch;
  }) || [];
};


export const fetchCategoryData = async (query, setCategoryData) => {
  const params = new URLSearchParams();
  // for (const key in query) {
  //   if (query[key] !== undefined && query[key] !== null) {
  //     params.append(key, query[key]);
  //   }
  // }
  params.append('per_page', 999);
  const resp = await getApi(`/product-category?${params.toString()}`);
  if (resp?.success === true) {
    setCategoryData(resp?.data?.productCategories?.data || []);
  }
  // return resp?.data?.productCategories || []
}
export const fetchCategoryDataFilter = async (query, search, page = 1) => {
  const params = new URLSearchParams();
  const resp = await getApi(`/product-category?search=${search}&page=${page}&per_page=50`);
  if (resp?.success === true) {
    const data = resp?.data?.productCategories?.data;

    const options = data.map(item => ({
      value: item.id,
      label: item.name || item.name_en || item.name_tc,
      name_tc: item.name_tc,
      code: item.code
    }));
    return {
      options,
      hasMore: resp?.data?.productCategories.total > page * 50
    };
  }
}

// Debounce helper that returns a debounced function which resolves all pending
// callers with the result of the final invocation within the wait window.
const debouncePromise = (fn, wait = 800) => {
  let timer = null;
  let pending = [];
  let lastThis;
  let lastArgs;
  return function(...args) {
    lastThis = this;
    lastArgs = args;
    if (timer) clearTimeout(timer);
    return new Promise((resolve, reject) => {
      pending.push({ resolve, reject });
      timer = setTimeout(async () => {
        const currentPending = pending;
        pending = [];
        timer = null;
        try {
          const result = await fn.apply(lastThis, lastArgs);
          currentPending.forEach(p => p.resolve(result));
        } catch (error) {
          currentPending.forEach(p => p.reject(error));
        }
      }, wait);
    });
  };
};

const _fetchCategoryDataFilterV2 = async (
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    origin_ids,
    product_ids,
    brands,
    pic_staff_member_import,
    pic_staff_member_sales,

    pa_codes,
    barcodes,
    convert_types,
    prepack_types,
  } = {}
) => {
  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");

  // optional filters
  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  // if (Array.isArray(category_ids)) {
  //   category_ids.forEach((id) => params.append("category_ids[]", id));
  // }
  if (Array.isArray(origin_ids)) {
    origin_ids.forEach((id) => params.append("origin_ids[]", id));
  }
  
  if (Array.isArray(brands)) {
    brands.forEach((brand) => params.append("brands[]", brand));
  }
  if (Array.isArray(product_ids)) {
  product_ids.forEach((str) => {
    if (typeof str === "string" && str.trim() !== "") {
      str
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id)
        .forEach((id) => params.append("product_ids[]", id));
    }
  });
}

  if (Array.isArray(pic_staff_member_sales)) {
    pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  }
  if (Array.isArray(pic_staff_member_import)) {
    pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  }
  if (Array.isArray(pa_codes)) {
    pa_codes.forEach((value) => params.append("pa_codes[]", value));
  }
  if (Array.isArray(barcodes)) {
    barcodes.forEach((value) => params.append("barcodes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }
  const resp = await getApi(`/direct_in_out/v2/product-category?${params.toString()}`);

  if (resp?.success === true) {
    const data = resp?.data?.productCategories?.data || [];

    const options = data.map((item) => ({
      value: item.id,
      label: item.name || item.name_en || item.name_tc,
      name_tc: item.name_tc,
      code: item.code,
    }));

    return {
      options,
      hasMore: resp?.data?.productCategories?.total > page * 50,
    };
  }

  return { options: [], hasMore: false };
};

export const fetchCategoryDataFilterV2 = debouncePromise(_fetchCategoryDataFilterV2, 300);


const _fetchProductGroupVarietiesFilterData = async  ( //V2
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    category_ids,
    origin_ids,
    brands,
    pic_staff_member_import,
    pic_staff_member_sales,

    pa_codes,
    barcodes,
    convert_types,
    prepack_types,
  }= {}
) => {


  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");

  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  if (Array.isArray(category_ids)) {
    category_ids.forEach((id) => params.append("category_ids[]", id));
  }
  if (Array.isArray(origin_ids)) {
    origin_ids.forEach((id) => params.append("origin_ids[]", id));
  }
  
  if (Array.isArray(brands)) {
    brands.forEach((brand) => params.append("brands[]", brand));
  }
 
  if (Array.isArray(pic_staff_member_sales)) {
    pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  }
  if (Array.isArray(pic_staff_member_import)) {
    pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  }
  if (Array.isArray(pa_codes)) {
    pa_codes.forEach((value) => params.append("pa_codes[]", value));
  }
  if (Array.isArray(barcodes)) {
    barcodes.forEach((value) => params.append("barcodes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }
  const resp = await getApi(`/product_group_names?${params.toString()}`);

  // const resp = await getApi(`/product_group_names?search=${search}&page=${page}&per_page=50`);
  if (resp?.success === true) {
    const data = resp?.data?.productGroupNames;

    const options = data.map(item => ({
      value: item.product_ids,
      label: item.group_name,

    }));
    return {
      options,
      hasMore: resp?.data?.productGroupNames?.total > page * 50
    };
  }
}

export const fetchProductGroupVarietiesFilterData = debouncePromise(_fetchProductGroupVarietiesFilterData, 300);

export const fetchOriginData = async (query, setOriginData) => {
  const params = new URLSearchParams();
  // for (const key in query) {
  //   if (query[key] !== undefined && query[key] !== null) {
  //     params.append(key, query[key]);
  //   }
  // }
  params.append('per_page', 999);
  const resp = await getApi(`/product-origin?${params.toString()}`);
  if (resp?.success === true) {
    setOriginData(resp?.data?.productOrigins?.data || []);
  }
  // return resp?.data?.productOrigins || []
}
export const fetchOriginDataFilter = async (query, search, page = 1) => {
  const params = new URLSearchParams();
  const resp = await getApi(`/product-origin?search=${search}&page=${page}&per_page=50`);
  if (resp?.success === true) {
    const data = resp?.data?.productOrigins?.data;

    const options = data.map(item => ({
      value: item.id,
      label: item.name || item.name_en || item.name_tc,
      name_tc: item.name_tc || '',
      code: item.code
    }));
    return {
      options,
      hasMore: resp?.data?.productOrigins.total > page * 50
    };
  }
}
const _fetchOriginDataFilterV2 = async (
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    category_ids,
    product_ids,
    brands,
    pic_staff_member_import,
    pic_staff_member_sales,

    pa_codes,
    barcodes,
    convert_types,
    prepack_types,
  } = {}
) => {
  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");

  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  if (Array.isArray(category_ids)) {
    category_ids.forEach((id) => params.append("category_ids[]", id));
  }
  // if (Array.isArray(origin_ids)) {
  //   origin_ids.forEach((id) => params.append("origin_ids[]", id));
  // }
  
  if (Array.isArray(brands)) {
    brands.forEach((brand) => params.append("brands[]", brand));
  }
  if (Array.isArray(product_ids)) {
  product_ids.forEach((str) => {
    if (typeof str === "string" && str.trim() !== "") {
      str
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id)
        .forEach((id) => params.append("product_ids[]", id));
    }
  });
}

  if (Array.isArray(pic_staff_member_sales)) {
    pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  }
  if (Array.isArray(pic_staff_member_import)) {
    pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  }
  if (Array.isArray(pa_codes)) {
    pa_codes.forEach((value) => params.append("pa_codes[]", value));
  }
  if (Array.isArray(barcodes)) {
    barcodes.forEach((value) => params.append("barcodes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }
  const resp = await getApi(`/direct_in_out/v2/product-origin?${params.toString()}`);

  if (resp?.success === true) {
    const data = resp?.data?.productOrigins?.data || [];

    const options = data.map((item) => ({
      value: item.id,
      label: item.name || item.name_en || item.name_tc,
      name_tc: item.name_tc || '',
      code: item.code,
    }));

    return {
      options,
      hasMore: resp?.data?.productOrigins?.total > page * 50,
    };
  }

  return { options: [], hasMore: false };
};

export const fetchOriginDataFilterV2 = debouncePromise(_fetchOriginDataFilterV2, 300);


export const fetchPicImportData = async (query, setPicImportData) => {
  const params = new URLSearchParams();
  // for (const key in query) {
  //   if (query[key] !== undefined && query[key] !== null) {
  //     params.append(key, query[key]);
  //   }
  // }
  params.append('type', 'import');
  params.append('per_page', 999);
  const resp = await getApi(`/product_pic_staff_member?${params.toString()}`);
  if (resp?.success === true) {
    setPicImportData(resp?.data?.data || []);
  }
  // return resp?.data;
}
export const fetchPicImportDataFilter = async (query, search, page = 1) => {
  const resp = await getApi(`/product_pic_staff_member?search=${search}&page=${page}&per_page=50&type=import`);
  if (resp?.success === true) {
    const data = resp?.data?.data;

    const options = data.map(item => ({
      value: item,
      label: item,
      name_tc: item,
      code: item
    }));
    return {
      options,
      hasMore: resp?.data?.data.total > page * 50
    };
  }
}

const _fetchPicImportDataFilterV2 = async(
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    category_ids,
    origin_ids,
    product_ids,
    brands,
    pic_staff_member_sales,

    pa_codes,
    barcodes,
    convert_types,
    prepack_types,
  }= {}
)  => {
  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");
  // params.append("type", "import");

  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  if (Array.isArray(category_ids)) {
    category_ids.forEach((id) => params.append("category_ids[]", id));
  }
  if (Array.isArray(origin_ids)) {
    origin_ids.forEach((id) => params.append("origin_ids[]", id));
  }
  
  if (Array.isArray(brands)) {
    brands.forEach((brand) => params.append("brands[]", brand));
  }
  if (Array.isArray(product_ids)) {
  product_ids.forEach((str) => {
    if (typeof str === "string" && str.trim() !== "") {
      str
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id)
        .forEach((id) => params.append("product_ids[]", id));
    }
  });
}

  if (Array.isArray(pic_staff_member_sales)) {
    pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  }
  // if (Array.isArray(pic_staff_member_import)) {
  //   pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  // }
  if (Array.isArray(pa_codes)) {
    pa_codes.forEach((value) => params.append("pa_codes[]", value));
  }
  if (Array.isArray(barcodes)) {
    barcodes.forEach((value) => params.append("barcodes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }
  const resp = await getApi(`/direct_in_out/v2/pic_import?${params.toString()}`);
  // const resp = await getApi(`/product_pic_staff_member?search=${search}&page=${page}&per_page=50&type=import`);
  if (resp?.success === true) {
    const data = resp?.data?.data;

    const options = data.map(item => ({
      value: item,
      label: item,
      name_tc: item,
      code: item,
    }));
    return {
      options,
      hasMore: resp?.data?.data.total > page * 50
    };
  }
}

export const fetchPicImportDataFilterV2 = debouncePromise(_fetchPicImportDataFilterV2, 300);
export const fetchPicSalesData = async (query, setPicSalesData) => {
  const params = new URLSearchParams();
  // for (const key in query) {
  //   if (query[key] !== undefined && query[key] !== null) {
  //     params.append(key, query[key]);
  //   }
  // }
  params.append('type', 'sales');
  params.append('per_page', 999);
  const resp = await getApi(`/product_pic_staff_member?${params.toString()}`);
  if (resp?.success === true) {
    setPicSalesData(resp?.data?.data || []);
  }
  // return resp?.data
}
export const fetchPicSalesDataFilter = async (query, search, page = 1) => {
  const resp = await getApi(`/product_pic_staff_member?search=${encodeURIComponent(search)}&page=${page}&per_page=50&type=sales`);
  if (resp?.success === true) {
    const data = resp?.data?.data;

    const options = data.map(item => ({
      value: item,
      label: item,
      name_tc: item,
      code: item
    }));
    return {
      options,
      hasMore: resp?.data?.data.total > page * 50
    };
  }
}
const _fetchPicSalesDataFilterV2 = async (
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    category_ids,
    origin_ids,
    product_ids,
    brands,
    pic_staff_member_import,

    pa_codes,
    barcodes,
    convert_types,
    prepack_types,
  }= {}
) => {
  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");
  params.append("type", "sales");

  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  if (Array.isArray(category_ids)) {
    category_ids.forEach((id) => params.append("category_ids[]", id));
  }
  if (Array.isArray(origin_ids)) {
    origin_ids.forEach((id) => params.append("origin_ids[]", id));
  }
  
  if (Array.isArray(brands)) {
    brands.forEach((brand) => params.append("brands[]", brand));
  }
  if (Array.isArray(product_ids)) {
  product_ids.forEach((str) => {
    if (typeof str === "string" && str.trim() !== "") {
      str
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id)
        .forEach((id) => params.append("product_ids[]", id));
    }
  });
}

  // if (Array.isArray(pic_staff_member_sales)) {
  //   pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  // }
  if (Array.isArray(pic_staff_member_import)) {
    pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  }
  if (Array.isArray(pa_codes)) {
    pa_codes.forEach((value) => params.append("pa_codes[]", value));
  }
  if (Array.isArray(barcodes)) {
    barcodes.forEach((value) => params.append("barcodes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }
  const resp = await getApi(`/direct_in_out/v2/pic_sales?${params.toString()}`);

  // const resp = await getApi(`/product_pic_staff_member?search=${encodeURIComponent(search)}&page=${page}&per_page=50&type=sales`);
  if (resp?.success === true) {
    const data = resp?.data?.data;

    const options = data.map(item => ({
      value: item,
      label: item,
      name_tc: item,
      code: item
    }));
    return {
      options,
      hasMore: resp?.data?.data.total > page * 50
    };
  }
}

export const fetchPicSalesDataFilterV2 = debouncePromise(_fetchPicSalesDataFilterV2, 300);

export const fetchBrand = async (query, setBrandData) => {
  const params = new URLSearchParams();
  for (const key in query) {
    if (query[key] !== undefined && query[key] !== null) {
      params.append(key, query[key]);
    }
  }
  const resp = await getApi(`/brand`)
  if (resp?.success) {
    setBrandData(resp?.data?.brands)
  }
  // return resp?.data
}
export const fetchBrandFilter = async (query, search, page = 1) => {
  const params = new URLSearchParams();
  const resp = await getApi(`/brand?search=${search}&page=${page}&per_page=50`);
  if (resp?.success === true) {
    const data = resp?.data?.brands;

    const options = data.map(item => ({
      value: item,
      label: item,
      name_tc: item,
      code: item
    }));
    return {
      options,
      hasMore: resp?.data?.brands.total > page * 50
    };
  }
}
const _fetchBrandFilterV2 = async (
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    category_ids,
    origin_ids,
    product_ids,
    pic_staff_member_import,
    pic_staff_member_sales,

    pa_codes,
    barcodes,
    convert_types,
    prepack_types,
  }= {}
) => {
  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");

  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  if (Array.isArray(category_ids)) {
    category_ids.forEach((id) => params.append("category_ids[]", id));
  }
  if (Array.isArray(origin_ids)) {
    origin_ids.forEach((id) => params.append("origin_ids[]", id));
  }
  
  // if (Array.isArray(brands)) {
  //   brands.forEach((brand) => params.append("brands[]", brand));
  // }
  if (Array.isArray(product_ids)) {
  product_ids.forEach((str) => {
    if (typeof str === "string" && str.trim() !== "") {
      str
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id)
        .forEach((id) => params.append("product_ids[]", id));
    }
  });
}

  if (Array.isArray(pic_staff_member_sales)) {
    pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  }
  if (Array.isArray(pic_staff_member_import)) {
    pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  }
  if (Array.isArray(pa_codes)) {
    pa_codes.forEach((value) => params.append("pa_codes[]", value));
  }
  if (Array.isArray(barcodes)) {
    barcodes.forEach((value) => params.append("barcodes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }
  const resp = await getApi(`/direct_in_out/v2/brand?${params.toString()}`);

  if (resp?.success === true) {
    const data = resp?.data?.brands || [];

    const options = data.map((item) => ({
      value: item,
      label: item,
      name_tc: item,
      code: item,
    }));

    return {
      options,
      hasMore: resp?.data?.brands?.total > page * 50,
    };
  }

  return { options: [], hasMore: false };
};

export const fetchBrandFilterV2 = debouncePromise(_fetchBrandFilterV2, 300);


export const fetchTypeFilter = async (query, search, page = 1) => {
  const params = new URLSearchParams();
  const resp = await getApi(`/product_types?search=${search}&page=${page}&per_page=50`);
  if (resp?.success === true) {
    const data = resp?.data?.data;

    const options = data.map(item => ({
      value: item,
      label: item,
      name_tc: item,
      code: item
    }));
    return {
      options,
      hasMore: resp?.data?.data.total > page * 50
    };
  }
}

// fetchbarcodes
// export const fetchBarcodes = async (query, search, page = 1) => {
//   const resp = await getApi(`/prepack-product/barcodes?search=${search}&page=${page}&per_page=50`);
//   if (resp?.success===true) {
//     const data = resp?.data?.barcodes?.data;
//     const options = data.map(item => ({
//       value: item,
//       label: item,
//     }));
//     return {
//       options,
//       hasMore: resp?.data?.barcodes?.total > page * 50
//     };
//   }
// }

const _fetchBarcodesV2 = async (
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    category_ids,
    origin_ids,
    product_ids,
    brands,
    pic_staff_member_import,
    pic_staff_member_sales,
    pa_codes,
    convert_types,
    prepack_types,
  } = {}
) => {
  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");

  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  if (Array.isArray(category_ids)) {
    category_ids.forEach((id) => params.append("category_ids[]", id));
  }
  if (Array.isArray(origin_ids)) {
    origin_ids.forEach((id) => params.append("origin_ids[]", id));
  }
  if (Array.isArray(brands)) {
    brands.forEach((brand) => params.append("brands[]", brand));
  }
  if (Array.isArray(product_ids)) {
    product_ids.forEach((str) => {
      if (typeof str === "string" && str.trim() !== "") {
        str
          .split(",")
          .map((id) => id.trim())
          .filter((id) => id)
          .forEach((id) => params.append("product_ids[]", id));
      }
    });
  }
  if (Array.isArray(pic_staff_member_sales)) {
    pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  }
  if (Array.isArray(pic_staff_member_import)) {
    pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  }
  if (Array.isArray(pa_codes)) {
    pa_codes.forEach((value) => params.append("pa_codes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }

  const resp = await getApi(`/prepack-product/barcodes?${params.toString()}`);

  if (resp?.success === true) {
    const data = resp?.data?.barcodes?.data || [];

    const options = data.map((item) => ({
      value: item,
      label: item,
    }));

    return {
      options,
      hasMore: resp?.data?.pagination?.current_page < resp?.data?.pagination?.last_page,
    };
  }

  return {
    options: [],
    hasMore: false,
  };
};

export const fetchBarcodes = debouncePromise(_fetchBarcodesV2, 300);

// export const fetchPaCodes = async (query, search, page = 1) => {
//   const resp = await getApi(`/prepack-product/pa_codes?search=${search}&page=${page}&per_page=50`);
//   if (resp?.success===true) {
//     const data = resp?.data?.paCodes?.data;
//     const options = data.map(item => ({
//       value: item,
//       label: item,
//     }));
//     return {
//       options,
//       hasMore: resp?.data?.paCodes?.total > page * 50
//     };
//   }
// }

const _fetchPaCodesV2 = async (
  query,
  search,
  page = 1,
  {
    search_product_name_code,
    category_ids,
    origin_ids,
    product_ids,
    brands,
    pic_staff_member_import,
    pic_staff_member_sales,
    barcodes,
    convert_types,
    prepack_types,
  } = {}
) => {
  const params = new URLSearchParams();

  // always include search + pagination
  params.append("search", search || "");
  params.append("page", page);
  params.append("per_page", "50");

  if (search_product_name_code) {
    params.append("search_product_name_code", search_product_name_code);
  }
  if (Array.isArray(category_ids)) {
    category_ids.forEach((id) => params.append("category_ids[]", id));
  }
  if (Array.isArray(origin_ids)) {
    origin_ids.forEach((id) => params.append("origin_ids[]", id));
  }
  if (Array.isArray(brands)) {
    brands.forEach((brand) => params.append("brands[]", brand));
  }
  if (Array.isArray(product_ids)) {
    product_ids.forEach((str) => {
      if (typeof str === "string" && str.trim() !== "") {
        str
          .split(",")
          .map((id) => id.trim())
          .filter((id) => id)
          .forEach((id) => params.append("product_ids[]", id));
      }
    });
  }
  if (Array.isArray(pic_staff_member_sales)) {
    pic_staff_member_sales.forEach((value) => params.append("pic_staff_member_sales[]", value));
  }
  if (Array.isArray(pic_staff_member_import)) {
    pic_staff_member_import.forEach((value) => params.append("pic_staff_member_import[]", value));
  }
  if (Array.isArray(barcodes)) {
    barcodes.forEach((value) => params.append("barcodes[]", value));
  }
  if (Array.isArray(convert_types)) {
    convert_types.forEach((value) => params.append("convert_types[]", value));
  }
  if (Array.isArray(prepack_types)) {
    prepack_types.forEach((value) => params.append("prepack_types[]", value));
  }

  const resp = await getApi(`/prepack-product/pa_codes?${params.toString()}`);

  if (resp?.success === true) {
    const data = resp?.data?.paCodes?.data || [];

    const options = data.map((item) => ({
      value: item,
      label: item,
    }));

    return {
      options,
      hasMore: resp?.data?.pagination?.current_page < resp?.data?.pagination?.last_page,
    };
  }

  return {
    options: [],
    hasMore: false,
  };
};

export const fetchPaCodes = debouncePromise(_fetchPaCodesV2, 300);
export const handleGetCustomerGroupFilter = async (query, search, page = 1) => {
  const resp = await getApi(`/customer-group?search=${search}&page=${page}&per_page=50&only_customer_groups=1`)
  if (resp?.success) {
    if (resp?.success === true) {
      const data = resp?.data?.customerGroups?.data;

      const options = data.map(item => ({
        value: item.group_id,
        label: item.name || item.name_en || item.name_tc,
        name_tc: item.name_tc,
        code: item.code
      }));
      return {
        options,
        hasMore: resp?.data?.customerGroups.total > page * 50
      };
    }
  }
}

export const fetchCustomerGroup = async (query) => {
  const params = new URLSearchParams();
  // for (const key in query) {
  //   if (query[key] !== undefined && query[key] !== null) {
  //     params.append(key, query[key]);
  //   }
  // }
  params.append('per_page', 999);
  params.append('only_customer_groups', 1);
  const resp = await getApi(`/customer-group?${params.toString()}`)
  if (resp?.success) {
    // setCustomerGroupData(resp?.data?.customerGroups?.data)
  }
  return resp?.data?.customerGroups
}

export const fetchProductList = async (query, setProductListData) => {
  const params = new URLSearchParams();
  // for (const key in query) {
  //   if (query[key] !== undefined && query[key] !== null) {
  //     params.append(key, query[key]);
  //   }
  // }
  params.append('per_page', 999);
  const resp = await getApi(`/product?${params.toString()}`);
  if (resp?.success === true) {
    setProductListData(resp?.data?.products?.data || []);
  }
  // return resp?.data?.products
}
export const fetchProductListFilter = async (query, search, page = 1) => {
  const params = new URLSearchParams();
  params.append('per_page', 50);
  const resp = await getApi(`/product?search=${search}&page=${page}&per_page=50`);
  if (resp?.success === true) {
    const data = resp?.data?.products?.data;

    const options = data.map(item => ({
      value: item.id,
      label: item.name || item.name_tc || item.name_en,
      name_tc: item.name_tc,
      code: item.code
    }));
    return {
      options,
      hasMore: resp?.data?.products.total > page * 50
    };
  }
}

export const fetchSuppliers = async (query = '', setSuppliers) => {
  try {
    const response = await getApi(
      `/suppliers?search=${encodeURIComponent(query)}&per_page=9999`
    );

    if (response?.success) {
      setSuppliers(response.data.suppliers?.data || []);
    } else {
      toast.error(response?.msg || 'Failed to fetch suppliers');
    }
  } catch (error) {
    toast.error(error.message || 'Failed to fetch suppliers');
  }
};

export const fetchShippingData = async (search = '', setShippingMethods) => {
  try {
    // setIsLoading(true);
    // setError(null);
    const resp = await getApi(`/shipping-method?search=${encodeURIComponent(search)}&per_page=999`);
    if (resp?.success === true) {
      setShippingMethods(resp.data.shippingMethods?.data);
    }
  } catch (error) {
    // setError(error.message || 'Failed to fetch shipping details');
  } finally {
    // setIsLoading(false);
  }
};

export const relatedProductsLoadOptions = (type, updateData) => async (inputValue, loadedOptions, { page }) => {
  console.log(type);

  const per_page = 20;
  const query = { page, per_page, search: inputValue };

  try {
    let response;
    if (type == 'category') {
      response = await fetchCategoryData(query);
    }
    if (type == 'origin') {
      response = await fetchOriginData(query);
    }
    if (type == 'import') {
      response = await fetchPicImportData(query);
    }
    if (type == 'sales') {
      response = await fetchPicSalesData(query);
    }
    if (type == 'brand') {
      response = await fetchBrand(query);
    }
    if (type == 'customerGroup') {
      response = await fetchCustomerGroup(query);
    }
    if (type == 'productName') {
      response = await fetchCustomerGroup(query);
    }
    if (type == 'product') {
      response = await getApi(`/product?${new URLSearchParams(query).toString()}`);
      response = response?.data?.products;
    }
    const productsResponse = response?.data || response?.brands || [];
    const pagination = response || {};
    const newOptions = productsResponse.map((product) => ({
      value: product.id || product,
      // label: `${product.name} | (${product.code})`,
      label: product.name && product.code
        ? `${product.name} | (${product.code})`
        : product.name_tc && product.code
          ? `${product.name_tc} | (${product.code})`
          : product.name
            ? product.name
            : product.name_tc ?
              product.name_tc
              : product.code
              ? product.code
              : String(product)
    }));

    return {
      options: newOptions,
      hasMore: pagination.current_page < pagination.last_page,
      additional: {
        page: page + 1,
      },
    };
  } catch (error) {
    console.error('Error loading products:', error);
    return {
      options: [],
      hasMore: false,
      additional: {
        page: 1,
      },
    };
  }
};

export const handleSelectionChange = (type, updateState) => (selectedOption) => {
  // if (!selectedOption) {
  //   // Clear selection if option is null (when cleared)
  //   if (type === 'category') {
  //     setSelectedCategoryIds([]);
  //   } else {
  //     setSelectedOriginIds([]);
  //   }
  //   return;
  // }

  const item = {
    id: selectedOption.value,
    name: selectedOption.label.split(' | ')[0],
    code: selectedOption.label.match(/\(([^)]+)\)/)?.[1] || ''
  };

  updateState(prev =>
    prev.includes(item.id)
      ? prev.filter(id => id !== item.id) // Remove if already selected
      : [...prev, item.id] // Add if not selected
  );

};

 
export function transformData(inoutData) {
  const output = [];
  const mainProductGroupData = inoutData?.mainProductOfGroups;
  const orderArrivalData = inoutData?.productOrderArrivals;
  const reserveProductData = inoutData?.sectionReserves?.productGroup?.heading || {};
  const headings = inoutData?.sections?.data || [];
  const combinedProductData = Object.values(headings)
    .filter(heading => heading.product_group_id)
    .map(heading => {
      const reserveData = reserveProductData[heading.product_group_id];
      return reserveData ? { ...heading, ...reserveData } : heading;
    });

  // const combinedProductData = { ...enrichedHeadings };

  // for (const [key, value] of Object.entries(arrivalsProductData)) {
  //   if (!combinedProductData.hasOwnProperty(key)) {
  //     combinedProductData[key] = value;
  //   }
  // }
  Object.values(combinedProductData || {}).forEach(productGroup => {
    const productGroupId = productGroup.group_no; // Use group_no as productGroupId
    const productGroupkey = productGroup?.group_key
    const groupNames = [];
    let colSpan = 0;
    const mainGroupData = mainProductGroupData[productGroupkey] || {};
    const mainOrderArrivalData = orderArrivalData[mainGroupData?.[0]?.product_id] || {};
    const customerGroupMap = {}; // To store data by customer group and subgroup

    Object.values(productGroup.customerGroups || {}).forEach(customerGroup => {
      const subGroups = Object.values(customerGroup.subGroup || {}).map(subGroup => {
        customerGroupMap[customerGroup.label] = customerGroupMap[customerGroup.label] || {};
        customerGroupMap[customerGroup.label][subGroup.name] = []; // Initialize subgroup array
        return {
          id: subGroup.id,
          name: subGroup.name
        };
      });
      groupNames.push({
        name: customerGroup.label,
        subGroups: subGroups
      });
      colSpan += subGroups.length;
    });

    const history = [];

    // Aggregate data and store in respective subgroups
    Object.values(inoutData?.sectionReserves?.productGroup?.data || {}).forEach(customerGroupData => {
      Object.values(customerGroupData).forEach(dateEntries => {
        Object.values(dateEntries).forEach(item => {
          if (item.product_group_group_no === productGroup.group_no) {
            const customerGroupLabel = item.customer_group_label;
            const customerSubGroupName = item.customer_sub_group_name;

            if (customerGroupMap[customerGroupLabel] && customerGroupMap[customerGroupLabel][customerSubGroupName]) {
              customerGroupMap[customerGroupLabel][customerSubGroupName].push({
                date: item.date,
                quantity: item.quantity,
                promotion_type: item.promotion_type,
                product_name_tc: item.product_name_tc
                // Add other relevant data fields
              });
            }
          }
        });
      });
    });

    // Aggregate history
    Object.values(inoutData?.sectionReserves?.productGroup?.history || {}).forEach(item => {
      if (item.product_group_id === productGroup.id) {
        // Adjust this logic based on how you want to aggregate history
        history.push({
          date: item.date,
          // Add other relevant history fields
        });
      }
    });

    const groupedData = groupNames.map(group => ({
      groupName: group.name,
      subGroups: group.subGroups.map(subGroup => ({
        subGroupName: subGroup.name,
        data: customerGroupMap[group.name]?.[subGroup.name] || []
      }))
    }));

    // for prepack inout page only
    if(productGroup?.prepack_product_type == 1 || productGroup?.prepack_product_type == 2){
      colSpan++; //for convertin
    }
    if (typeof productGroup?.finished_product_codes == 'object') {
      colSpan += Object.keys(productGroup?.finished_product_codes).length; // for convertout
    }
    // for direct inout page only
    // if(productGroup?.is_raw_product){
    //   console.log("productGroup?.is_raw_product", productGroup?.is_raw_product);
    //   console.log('group number ', productGroupId)
    //   colSpan++;
    // }
    
    output.push({
      productGroupId: productGroupId, //this is product group no.
      productGroupkey: productGroupkey,
      groupNames: groupNames,
      colSpan: colSpan,
      groupedData: groupedData,
      history: history,
      maiProductGroup: mainGroupData,
      orderArrivalData: mainOrderArrivalData,

      prepackProductType: productGroup?.prepack_product_type,
      finishedProductCodes: productGroup?.finished_product_codes || {},
      finishedProductNames: productGroup?.finished_product_names || {},
      finishedProductConvertRatios: productGroup?.finished_product_convert_ratios || {},
      finishedProductPrepackTypes: productGroup?.finished_product_prepack_types || {},
      finishedProductSpecialPeriods: productGroup?.finished_product_special_periods || {},
      paCode: productGroup?.pa_code,
      barcode: productGroup?.barcode,
      isRawProduct: productGroup?.is_raw_product
    });
  });

  return output;
}

export function transformDataProduct(inoutData) {
  const output = [];

  Object.values(inoutData?.sectionReserves?.product?.heading || {}).forEach(productGroup => {
    const productGroupId = productGroup.id; // Use group_no as productGroupId
    const productGroupkey = productGroup?.name_tc
    const groupNames = [];
    let colSpan = 0;

    const customerGroupMap = {}; // To store data by customer group and subgroup

    Object.values(productGroup.customerGroups || {}).forEach(customerGroup => {
      const subGroups = Object.values(customerGroup.subGroup || {}).map(subGroup => {
        customerGroupMap[customerGroup.label] = customerGroupMap[customerGroup.label] || {};
        customerGroupMap[customerGroup.label][subGroup.name] = []; // Initialize subgroup array
        return {
          id: subGroup.id,
          name: subGroup.name
        };
      });
      groupNames.push({
        name: customerGroup.label,
        subGroups: subGroups
      });
      colSpan += subGroups.length;
    });

    const history = [];

    // Aggregate data and store in respective subgroups
    Object.values(inoutData?.sectionReserves?.productGroup?.data || {}).forEach(customerGroupData => {
      Object.values(customerGroupData).forEach(dateEntries => {
        Object.values(dateEntries).forEach(item => {
          if (item.product_group_group_no === productGroup.group_no) {
            const customerGroupLabel = item.customer_group_label;
            const customerSubGroupName = item.customer_sub_group_name;

            if (customerGroupMap[customerGroupLabel] && customerGroupMap[customerGroupLabel][customerSubGroupName]) {
              customerGroupMap[customerGroupLabel][customerSubGroupName].push({
                date: item.date,
                quantity: item.quantity,
                promotion_type: item.promotion_type,
                product_name_tc: item.product_name_tc
                // Add other relevant data fields
              });
            }
          }
        });
      });
    });

    // Aggregate history
    Object.values(inoutData?.sectionReserves?.productGroup?.history || {}).forEach(item => {
      if (item.product_group_id === productGroup.id) {
        // Adjust this logic based on how you want to aggregate history
        history.push({
          date: item.date,
          // Add other relevant history fields
        });
      }
    });

    const groupedData = groupNames.map(group => ({
      groupName: group.name,
      subGroups: group.subGroups.map(subGroup => ({
        subGroupName: subGroup.name,
        data: customerGroupMap[group.name]?.[subGroup.name] || []
      }))
    }));

    output.push({
      productGroupId: productGroupId,
      productGroupkey: productGroupkey,
      groupNames: groupNames,
      colSpan: colSpan,
      groupedData: groupedData,
      history: history
    });
  });

  return output;
}





export const dateFormat = (value) => {
  if (!value) return "";
  let dates = value;
  if (typeof dates === 'string') {
    if (!dates.includes("T") && !dates.includes("Z")) {
      dates = dates.replace(" ", "T") + 'Z';
    } else if (dates.includes("T") && !dates.includes("Z")) {
      dates = dates + 'Z';
    }
  }
  const dt = new Date(dates);
  if (isNaN(dt.getTime())) return value;

  const datePart = dt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  const timePart = dt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${datePart}, ${timePart.toUpperCase()}`;
}

export const checkCurrentOrBeforeDate = (nextDate) => {
  return new Date(nextDate).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
};

export const getUpdatedSelection = (
  selectedCellsForSum,
  rowIndex,
  colIndex,
  quantity
) => {
  console.log('auantitiy:', quantity);

  const key = `${rowIndex}-${colIndex}`;
  const isSelected = selectedCellsForSum[key] !== undefined;

  const firstKey = Object.keys(selectedCellsForSum)[0];
  const alreadySelectedCol = firstKey ? Number(firstKey.split("-")[1]) : null;

  let newSelection = { ...selectedCellsForSum };

  if (alreadySelectedCol !== null && alreadySelectedCol !== colIndex) {
    // reset with only this cell
    newSelection = { [key]: quantity };
  } else if (isSelected) {
    // toggle off this cell
    const { [key]: _, ...rest } = newSelection;
    newSelection = rest;
  } else {
    // add this cell
    newSelection[key] = quantity;
  }

  return newSelection;
};
